import ClipCatalogTile from "./ClipCatalogTile";

export default function ClipCard({ clip }) {
	return <ClipCatalogTile clip={clip} />;
}
